// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function Make(Config) {
  let use = () => {
    let match = React.useState(() => {});
    let setState = match[1];
    let focus = focus$1 => setState(param => Primitive_option.some(focus$1));
    let clearFocus = () => setState(param => {});
    return {
      focusedField: match[0],
      focus: focus,
      clearFocus: clearFocus
    };
  };
  return {
    use: use
  };
}

exports.Make = Make;
/* react Not a pure module */
